export const COPY_URL = 'socialSharing.copy.url';
